(() => {
  const initProjectCityFilters = () => {
    const sections = document.querySelectorAll(".content-cards-section, .project-city-cards-section");

    sections.forEach((section) => {
      const cards = Array.from(section.querySelectorAll("[data-city-card]"));
      if (cards.length <= 6) return;

      let filter = section.querySelector("[data-city-filter]");
      const grid = section.querySelector(".grid");
      if (!grid) return;

      if (!filter) {
        filter = document.createElement("div");
        filter.className = "city-filter";
        filter.setAttribute("data-city-filter", "auto");
        filter.setAttribute("aria-label", "熱門城市項目篩選");
        filter.innerHTML = `
          <button class="city-filter__button is-active" type="button" data-city-filter-button="中山" data-track="project-city-filter" data-track-label="中山" aria-pressed="true">
            <span class="city-filter__name">中山</span>
            <span class="city-filter__meta">查看項目</span>
          </button>
          <button class="city-filter__button" type="button" data-city-filter-button="珠海" data-track="project-city-filter" data-track-label="珠海" aria-pressed="false">
            <span class="city-filter__name">珠海</span>
            <span class="city-filter__meta">查看項目</span>
          </button>
        `;
        grid.parentNode.insertBefore(filter, grid);
      }

      if (filter.dataset.cityFilterReady === "true") return;
      filter.dataset.cityFilterReady = "true";
      filter.classList.add("is-ready");

      const buttons = Array.from(filter.querySelectorAll("[data-city-filter-button]"));
      const applyCity = (city) => {
        buttons.forEach((button) => {
          const isActive = button.getAttribute("data-city-filter-button") === city;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });

        cards.forEach((card) => {
          card.classList.toggle("is-hidden", card.getAttribute("data-city-card") !== city);
        });
      };

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          applyCity(button.getAttribute("data-city-filter-button"));
        });
      });

      applyCity("中山");
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProjectCityFilters);
  } else {
    initProjectCityFilters();
  }
  window.addEventListener("load", initProjectCityFilters);
})();
